import { MODEL_TYPES } from '../GeoMMM/ScenarioPlanning/ScenarioPlanningUtils';

// Config for the tabbed MMM shell. The DTC/Commerce splits use it — these
// two share the full tabbed UI (Model Results, Scenario Planning, FAQ, Offline
// Inputs) and differ only by title/URL and which model_type of run they show. This is
// distinct from the standalone DtcCommerceMmm dashboard (see ./DtcCommerceMMM), which
// is a separate, newer UI living at /dtc-mmm_new and /commerce-mmm_new.
export interface MmmVariantConfig {
  key: string; // URL segment / useTabbedNav baseURL
  title: string; // page title
  pageType: string; // analytics label
  scenarioModelType: (typeof MODEL_TYPES)[keyof typeof MODEL_TYPES];
  // mmm_job_dates.model_type to filter /dateOptions by (dtc | commerce). Undefined for
  // plain rMMM, which shows every run regardless of model_type.
  modelType?: string;
  // Future seams (unused today — all variants share data + tabs):
  // tabs?: readonly string[]; runSource?: { discoverEndpoint: string; toggleEndpoint: string };
}

export const RMMM_DTC_CONFIG: MmmVariantConfig = {
  key: 'dtc-mmm',
  title: 'DTC MMM',
  pageType: 'MMM',
  scenarioModelType: MODEL_TYPES.R_MMM,
  modelType: 'dtc'
};

export const RMMM_COMMERCE_CONFIG: MmmVariantConfig = {
  key: 'commerce-mmm',
  title: 'Commerce MMM',
  pageType: 'MMM',
  scenarioModelType: MODEL_TYPES.R_MMM,
  modelType: 'commerce'
};
